import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/ui/MobileApp.jsx");
